import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import {
  deleteadministrationList,
  deleteadministratior,
} from '../../../../api/api'
const DeleteModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { setIsFresh } = props
  const id = props.info.id
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    deleteadministratior(id).then((res) => {
      console.log(res)
      setIsFresh((pre) => !pre)
    })
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  return (
    <>
      <a type="primary" onClick={showModal}>
        删除
      </a>
      <Modal
        title="请确认"
        open={isModalOpen}
        onOk={handleOk}
        okText="确认"
        cancelText="取消"
        onCancel={handleCancel}
      >
        <p>您确定要删除此成员吗？删除后不可恢复</p>
      </Modal>
    </>
  )
}
export default DeleteModal
